module.exports = __webpack_public_path__ + "static/payment-12eb7f4242366115fd43eb8c3e92c779.png";